import type { Meta, StoryFn } from '@storybook/react';

import { Avatar, Link, MenuButton, MetaList, Status, SummaryItem } from '@pega/cosmos-react-core';
import type { SummaryItemProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/SummaryItem',
  component: SummaryItem,
  parameters: {
    layout: 'centered'
  }
} as Meta;

type SummaryItemStoryProps = SummaryItemProps & {
  showSecondary?: boolean;
  showVisual?: boolean;
  showActions?: boolean;
};

export const SummaryItemDemo: StoryFn<SummaryItemStoryProps> = (args: SummaryItemStoryProps) => {
  return (
    <SummaryItem
      primary='This is the primary info'
      secondary={
        args.showSecondary ? (
          <MetaList
            items={[
              'email@example.com',
              <Status variant='success'>Verified</Status>,
              <>
                Go to{' '}
                <Link href='https://www.pega.com' target='_blank'>
                  Pega.com
                </Link>
              </>
            ]}
          />
        ) : undefined
      }
      layout={args.layout}
      visual={
        args.showVisual ? (
          <Avatar
            size='l'
            name='Random Man'
            imageSrc='https://randomuser.me/api/portraits/men/41.jpg'
          />
        ) : undefined
      }
      actions={
        args.showActions ? (
          <MenuButton
            text='Options'
            variant='simple'
            icon='more'
            iconOnly
            menu={{
              items: ['Option Number 1', 'Option Number 2', 'Option Number 3'].map(name => ({
                id: name,
                primary: name
              }))
            }}
          />
        ) : undefined
      }
    />
  );
};

SummaryItemDemo.args = {
  showSecondary: true,
  layout: 'stacked',
  showVisual: true,
  showActions: true
};

SummaryItemDemo.argTypes = {
  showSecondary: { control: { type: 'boolean' } },
  layout: { options: ['stacked', 'inline'], control: { type: 'select' } },
  showVisual: { control: { type: 'boolean' } },
  showActions: { control: { type: 'boolean' } }
};
